export default __webpack_public_path__ + "static/media/206.1e5491be.jpg";